export interface Lesson {
  id: string;
  folderId?: string;
  organizationId: string;
  title: string;
  description: string;
  poster?: string;
  supplementalType?: number;
  supplementalLessonId?: string;
  order: number;
  amountOfRetries?: number;
  isGradable: boolean;
  newImage?: File;
  supplementalLesson?: Lesson;
  passingScore?: number;
  libraryMediaFiles: any[];
  isSupplementalLesson?: boolean;
  lessonContentId?: string;
  isPublished?: boolean;
  inProgress?: boolean;
  isFinalAssessment?: boolean;
  addAckNode?: boolean;
  // Generation settings copied onto microreel lessons at creation (null on
  // lessons generated before the backend change and on video-source reels
  // for gender). language/dialect use the generation form's keys ('en', 'US').
  language?: string;
  dialect?: string;
  gender?: string;
  type?: number;
}

export interface LessonShortModel {
  lessonId: string;
  lessonName: string;
}

export const isLessonFinalAssessment = (lesson: Lesson) => {
  return (
    lesson.isFinalAssessment === true ||
    lesson.title?.toLowerCase().includes('final assessment') ||
    lesson.title?.toLowerCase().includes('asesiad terfynol')
  );
};

export interface LessonCreateModel {
  folderId?: string;
  organizationId: string;
  title: string;
  description: string;
  order: number;
  isGradable: boolean;
  libraryMediaFiles: any[];
  isSupplementalLesson?: boolean;
}

export interface LessonIsPublishedModel {
  publishedId: string;
}
